import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'src/redux/store';

import { APP_FULL_NAME } from '../constants/common';
import { ROUTES } from '../constants/routes';

const OnboardingRoute = ({ component: Component, title, ...props }: any) => {
    const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

    const isOnboardingCompleted = useSelector((state: RootState) => state.auth.currentUser?.isSetBasicDetail);
    const appearance = useSelector((state: RootState) => state.basic.appearance);

    useEffect(() => {
        document.title = `${title} - ${appearance.web_title ?? APP_FULL_NAME}`;
        const favicon = document.getElementById('favicon') as HTMLLinkElement;

        // Only override the default favicon when the org has actually set one — otherwise keep the existing icon
        if (favicon && appearance?.favicon) {
            favicon.href = appearance.faviconUrl + appearance.favicon;
        }
    }, [title, appearance]);

    return isAuthenticated && !isOnboardingCompleted ? <Component {...props} /> : <Navigate to={ROUTES.LOGIN} />;
};

export default OnboardingRoute;
